import {
  Button,
  Form,
  InputNumber,
  message,
  Modal,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useGetRequest from "../../hooks/useGetRequest";
import { Return } from "../../types/return.type";
import { api } from "../../api/api";

const { Title } = Typography;

export default function Returns() {
  const { itemId, name } = useParams();
  const [returns, setReturns] = useState<Return[]>([]);
  const { data, loading, refresh } = useGetRequest(`/order/returns/${itemId}`);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      console.log(data);

      setReturns(data.returns);
    }
  }, [data]);

  const handleCreateReturn = async (values: Partial<Return>) => {
    setConfirmLoading(true);
    try {
      await api.post(`/order/returns/${itemId}`, values);
      message.success("Возврат успешно добавлен.");
    } catch (error: any) {
      console.error("Ошибка добавления возврата.", error);
      message.error(error.response.data.error);
    } finally {
      setConfirmLoading(false);
      setIsModalOpen(false);
      refresh();
    }
  };

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Пользователь",
      dataIndex: "ownerUsername",
      key: "ownerUsername",
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title level={2}>Возвраты {name}</Title>
        <Button type="primary" onClick={() => setIsModalOpen(true)}>
          Добавить
        </Button>
      </div>
      <Table
        loading={loading}
        columns={columns}
        dataSource={returns}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />

      <Modal
        title="Добавить возврат"
        open={isModalOpen}
        confirmLoading={confirmLoading}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleCreateReturn}>
          <Form.Item
            name="quantity"
            label="Количество"
            rules={[{ required: true, message: "Пожалуйста, введите кол-во" }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
